const hf = () => (window as any)?.Telegram?.WebApp?.HapticFeedback;

export const useHaptic = () => ({
  impact: (style: 'light' | 'medium' | 'heavy' = 'light') => hf()?.impactOccurred(style),
  success: () => hf()?.notificationOccurred('success'),
  error: () => hf()?.notificationOccurred('error'),
  warning: () => hf()?.notificationOccurred('warning'),
  selection: () => hf()?.selectionChanged(),
});
